// import { UserState } from "redux-oidc";
import { RouterState } from "react-router-redux";
import {uiItemNames,buttonActionTypes, impMode, pdfMode, currPathValue, LANG} from './enums'
import { ActionType } from 'typesafe-actions';
import {ThunkAction} from 'redux-thunk'
import {User} from 'oidc-client'
import { setAppSettings, setStateItem, setUiProperty, setUser } from "../actions/actionsBase";
// import { Core, WebViewerInstance } from "@pdftron/webviewer";

export type SetPropertyAction = ActionType<typeof setUiProperty>;
export type SetItemAction = ActionType<typeof setStateItem>;
export type SetUserAction = ActionType<typeof setUser>;
export type SetAppSettingsAction = ActionType<typeof setAppSettings>;

export type AppActions = SetPropertyAction | SetItemAction | SetUserAction;
export type ThunkResult<R> = ThunkAction<R, IState, undefined, AppActions>;

export interface AppRoutes {
    home: string;
    callback: string;
    main: string;
}

export interface AppSettings {
    // dssUrl: string;
    webViewerServer: string;
    pdfTronLic: string;
    ertms: diClass;
    retteflyt: diClass;
    validFileTypes: string;
    requiredGroups: string;
    apimSubKey: string;
}

export interface diClass {
    class: number;
    type: number;
}

export interface BasicAppProps
{
    isVisible:boolean;
    isLoading:boolean;
    hasErrored:boolean;
}

export interface IState 
{    
    oidc: User|null;
    uiState: UiState;
    uiItems: UiItemState;
    appSettings:AppSettings; 
    routing: RouterState;
}

export interface UiState {
    MAIN_CONTAINER_IsLoading: boolean;
    MAIN_CONTAINER_IsVisible: boolean;
    MAIN_CONTAINER_HasErrored: boolean;

    DATA_CONTAINER_IsLoading: boolean;
    DATA_CONTAINER_IsVisible: boolean;
    DATA_CONTAINER_HasErrored: boolean;

    DOC_DATA_CONTAINER_IsLoading: boolean;
    DOC_DATA_CONTAINER_IsVisible: boolean;
    DOC_DATA_CONTAINER_HasErrored: boolean;

    PDF_VIEWER_CONTAINER_IsLoading: boolean;
    PDF_VIEWER_CONTAINER_IsVisible: boolean;
    PDF_VIEWER_CONTAINER_HasErrored: boolean; 
    PDF_VIEWER_INIT_IsLoading: boolean;

    [index: string]: boolean;
}

export class ReqError
{
    statusText:string;
    error:string;
    constructor(statusText:string,error:string) { 
        this.statusText = statusText;
        this.error = error;
     } 
} 

export class ErrorResponse
{
    Message:string;
    ExceptionMessage:string;
    ExceptionType:string;
    StackTrace:string;
    InnerException: object;
    constructor(Message:string,ExceptionMessage:string, ExceptionType: string,StackTrace: string, InnerException: object ) { 
        this.Message = Message;
        this.ExceptionMessage = ExceptionMessage;
        this.ExceptionType = ExceptionType;
        this.StackTrace = StackTrace;
        this.InnerException = InnerException;
     } 
} 

export type UiItemsTypes = any|string[];

export interface UiItemState
{
    [uiItemNames.currentUser]: PaUser;
    [uiItemNames.currentUserGroups]: UserGroup[];
    [uiItemNames.hasRequiredGroups]: boolean;
    [uiItemNames.currentPath]: currPathValue;
    [uiItemNames.previousPath]: currPathValue[];
    [uiItemNames.recentDocuments]: PaDocumentV2[];
    [uiItemNames.favoriteDocuments]: PaDocumentV2[];
    [uiItemNames.myActivities]: activityItem[];
    [uiItemNames.selectedDocument]: PaDocument|null;
    [uiItemNames.selectedActivity]: activityItem|null;
    [uiItemNames.OpenFileInfo]: OpenFileInfo|null; 
    [uiItemNames.pdfViewerClientSide]: boolean; 
    [uiItemNames.pdfViewerMode]: pdfMode; 
    [uiItemNames.documentSearchList]: PaDocumentV2[];
    [uiItemNames.revisionPermisions]: RevisionPermisions[],
    [uiItemNames.errorMsgVisible]: boolean,
    [uiItemNames.errorMessage]: any;
    [uiItemNames.language]: LANG;
    [uiItemNames.actItemBL]: any;
    [uiItemNames.actRecsBL]: any;

    [index: string]: any;
}

export interface myInfo {
    userId: string;
    token: string;
}

export interface WfItem {
    workflowMessage: workflowMessage;
    documents: wfDocument[];
    recipients: wfRecipient[];
}


export interface workflowMessage {
    workflowRno: number;
    name: string;
    description: string;
    notes: string;
    workflowTemplateRno: number;
    workflowClassRno: number;
    plannedCloseDate: string;
    calendar: string;
    rfiMandatory: boolean;
    estimatedDays: number;
    sentDate: string;
    createdDate: string;
}

export interface qsDocument {
    rno: number;
    repositoryRno: number;
    id: string;
    title: string;
    documentMetaItems: documentMetaItems
}

export interface documentMetaItems {
    status: string;
	db_rno: number;
	doc_rno: number;
	doc_id: string;
	title: string;
    RepositoryName: string;
}

export interface wfDocument {
    revisionId: string;
    revisionRno: number;
    revisionStatus: string;
    forInfoOnly: boolean;
    sequenceNo: number;
    reasonForIssue: string|null,
    workflowRno: number;
    repositoryRno: number;
    documentRno: number;
    documentId: string;
    documentTitle: string;
    repositoryName: string;
    globalId: string;
    latestRevisionRno: number;
    revisions: WfDocRevision[];
}

export interface  WfDocRevision
{
    revisionId: string;
    revisionRno: number;
    revisionStatus: string;
}

export interface activityDecisions {
    activityRno: number;
    question: string;
    choices: choice[]
}

export interface choice {
    choice: string;
}

export interface activityItem {
    ReceivedDate: string;
    WorkflowItem: PaWorkflowItem;
    ActivityTemplate: any;
    Recipient: any;
    Id: number;
    DueDate: string;
    ClosedDate: string;
    Decision: string;
    Workdays: number;
    WfDocuments: wfDocument[];
    Decisions: activityDecisions|null;
    PaDocuments: PaDocument[];
    WfComments: wfComments[];
    AcknowledgedDate: string;
}

export interface wfComments {
    commentRno: number;
    comment: string;
    created: string;
    commentedByUserRno: number;
    commentedByUserId: string;
    commentedByUserName: string;
    commentSequence: number;
    commentType: number;
    fileRno: number;
    isDeleted: false,
    parentCommentRno: number;
    attachmentsCount: number;
    fileName: null|string;
    documentRno: number;
    docId: null|string;
    revisionId: null|string;
    revisionRno: number;
    repositoryRno: number;
    workflowRno: number;
    workflowTemplateRno: number;
    workflowClassRno: number;
    workflowName: string;
    activityRno: number;
    activityId: number;
    activityName: string;
    Attachments: Attachment[];
}

export interface PaDocumentComments {
    CommentId: number;
    ParentCommentId: number;
    CommentSequence:number;
    Created: string;
    CommentedBy: any;
    Text: string;
    CommentType: number;
    MetaItems: any;
    DocumentInfo: any;
    Attachments: Attachment[];
}

export interface Attachment {
    FileRno: number;
    OriginalFileName: string;
    Extension: string;
}

export interface PaWorkflowItem {
    Id: number;
    Name: string;
    Description: string;
    Notes: string;
    WorkflowTemplateId: number;
    WorkflowClassId: number;
}

export interface wfRecipient {
    priority: number;
    workflowRno: number;
    activityId: number;
    activityName: string;
    recipientId: string;
    recipientName: string;
    sequenceNumber: number;
    workdays: number;
    validated: boolean;
    plannedReceived: string;
    plannedDueDate: string;
}


export interface wfRecSearchList {
    items: recSearchItem[];
}

export interface recSearchItem {
    name: string;
    contactPersonId: string;
    eMail: string;
    companyName: string;
}

export interface UserGroup {
    groupRno: number;
    name: string;
    id: string;
}

export interface RecipientGroup {
    recipientGroupRno: number;
    name: string;
    id: string;
}


export interface WfTemplate {
    workflowClassRno: number;
    name: string;
    description: string;
    wfTypes: wfType[];
}

export interface wfType {
    workflowTemplateRno: number;
    name: string;
    description: string;
    numberGenerationType: number;
    prefix: string;
    calendarId: string;
    rfiMandatory: number;
    wfAct: wfAct[];
}

export interface wfAct {
    activityId: number;
    name: string;
    defaultDays: number;
    defaultRecipient: string;
    sortOrder: number;
    selectFilesToAttach: number;
}

export interface Archive {
    DbRno: number;
    Name: string;
    RevisionDefinition: RevisionDefinition;
}

export interface RevisionDefinition {
    AllowEmptyRevisionCode: boolean;
    RevisionCodeMethod: number;
    Manual: boolean;
    MandatoryRevisionCodes: boolean;
    AcceptOnlyPredefinedCodes: boolean;
    AutomaticNumberingMethod: number;
    ManualOverrideRevisionCode: boolean;
    NumberOfRevisionCodeChars: number;
    DefaultRevisionCode: string;
    StatusDefinition: StatusDefinition;
    CreateRevisionOnNewDocumentProfile: boolean;
    ShowRevision: number;
}

export interface StatusDefinition {
    IsMandatory: boolean;
    Default: string;
  }

export interface RevisionCode {
    Revision: string,
    Description: string
}

export interface Folder {
    FolderId: number,
    ParentFolderId: number,
    FolderName: string,
    Count: number,
    HasChildren: boolean,
    Children: Folder[]
  }

export interface OpenFileInfo {
    FilePath:string,
    File:FileInfo
  }

export interface FileInfo {
    FileRno: number;
    DocRno: number;
    RevRno: number;
    Size: number;
    OriginalFileName: string;
    Name: string;
    Extension: string;
    Status: number;
    StatusUser: any;
    StatusDate: Date;
    Comment: string;
}

export class apiPath{
    serviceName: string;
    methodName: string;
    constructor(serviceName:string,methodName:string) { 
        this.serviceName = serviceName;
        this.methodName = methodName;
     } 
}



export interface PaDocument{
    // SelectedRevId: number,
    ArchiveName: string,
    DocId: string,
    DbRno: number,
    DocRno: number,
    RevisionToUpdate: PaRevision,
    CurrentRevision: PaRevision,
    Revisions: PaRevision[],
    TypeName: string,
    CurrentRevisionRno: number,
    MetaItems: MetaItem[],
    SelectedRevPermisions: RevisionPermisions|null,
    Comments: PaDocumentComments[],
    WfComments: wfComments[]
    
}

export interface PaDocumentV2 {
    repositoryRno: number,
    documentRno: number,
    documentId: string,
    documentTitle: string,
    status: string,
    repositoryName: string, 
}

export interface PaRevision {
    $id: string;
    $ref: string;
    RevisionLog: any;
    RevSeqno: number;
    StatusDate: string;
    DocRno: number;
    DbRno: number;
    Files: PaFile[];
    FileCount: number;
    Initiated: string;
    StatusBy: any//PaUser|null;
    StatusTypeRno: number;
    InitiatedBy: any//PaUser|null;
    Created: string;
    CreatedBy: any//PaUser|null;
    Status: string;
    RevRno: number;
    Rno: number;
    RevisionCode: string;
    Closed: boolean;
    MetaItems: MetaItem[];//|any;
    TypeName: string;
}

export interface MetaItemPresentations {
    DbRno: number;
    MetaItemPresentations: MetaItemPresentation[];
}

export interface MetaItemPresentation {
      ShowDropDownIcon: boolean;
      MaximumCharacters: number;
      Name: string;
      Visible: boolean;
      Mandatory: boolean;
      Enabled: boolean;
      LabelText: string;
}
export interface MetaItemPresentationValue {
        Value: string;
        MetaItems: MetaItem[];
}

export interface RevisionPermisions {
    DocRno: number;
    RevRno: number;
    FileUserAccesses: FileUserAccesses[]
}

export interface FileUserAccesses {
    FileRno: number;
    CanEdit: boolean;
    CanView: boolean;
    CanCheckOut: boolean;
    CanCheckIn: boolean;
    CanExport: boolean;
    CanCheckOutForCommenting: boolean;
    CanCheckinComments: boolean;
}

export interface MetaItem {
    Name: string;
    Value?: any;
    HasMultipleValues: boolean;
    MultipleValues?: string[];
}

export interface NewMetaItemValues {
    DocumentID: string;
    NewRevision: boolean;
    NewRevCode: string;
    Status: string;
    Description: string;
    SaveResult: string;

    [index: string]: any;
}

export interface PaUser {
    fullName: string;
    userRno: number;
    userId: string;
    eMail: string;
    isActive: boolean;
}

export interface IamConfigSaveValue {
    roleId: string;
    userRno: number;
}

export interface IamConfig {
    roleId: string;
    roleDesc: string;
    apiPath: string;
    payload: string;
}

export interface MetaItemValue {
    DocumentID: string;
    Attribute: string;
    Value: any;
}

export interface RevStatusCode {
    Value: string;
    Description: string
}

export interface ProarcSetting {
        key: string;
        value: string;
}

export interface MassFileUploadOperation{
    id: string,
    filesToUpload: FileUploadInfo[],
    dssUploaded: boolean,
    proarcUploaded: boolean,
    inProgress: boolean,
    mode:impMode,
    confirmedForImport:wizData[],
    initWizData: wizData[],
    selectionsMade: wizSelection[],
    revisionsCreated: PaRevision[],
    [index: string]: any;
}

export interface FileUploadInfo{
    name: string,
    path: string,
    size: number,
    type: string,
    fileObj: File|undefined,
    pathOnDss: string,
    canceled: boolean,
    errored: boolean,
    filesMatched: PaFile[],
    docsMatched: PaDocument[],
    finished: boolean,
}

export interface PaFile {
    $id: string;
    UpdateWhenOpen: boolean
    IsIndexed: boolean,
    DateLastChanged: string,
    Size: number,
    OriginalFileName: string,
    LastUpdatedOnSite: number,
    DocPathId: number,
    DbRno: number,
    DocRno: number,
    RevRno: number,
    Version: number,
    Role: number,
    Visibility: number,
    ParentRno: number,
    PreviewRno: number,
    ThumbnailRno: number,
    RelatedFilesCount: number,
    CheckSum: string,
    Virtual: boolean,
    SiteRno: number,
    RevisionFileSeqno: number,
    CheckedOutFilePath: string,
    TemplateRno: number,
    GlobalFileId: string,
    GlobalParentFileId: string,
    Rno: number,
    FileRno: number,
    Name: string,
    Extension: string,
    Status: number,
    StatusUser: any,
    StatusDate: string,
    Comment: string,
    ProduceFileStatus: number,
    MetaItems: MetaItem[],
    TypeName: string
  }


export interface wizData {mode:wizMode|null,selection:wizSelection,step:number,wFileInfo:FileUploadInfo,fileName:string}
export interface wizSelection {paObj:PaFile|PaDocument|PaRevision|null, selectedRevRno:number|null, fileName:string}
export enum wizMode {replace = 'replace', newDoc='newDoc'}
export interface keyValuePair {Name:string, Value:any, Property:string}


export function mapActionToMethod(buttonAction:buttonActionTypes,param:string, param2?:string):apiPath {
    var mappings:apiPath;
    switch (buttonAction) {
        case buttonActionTypes.GET_MY_INFO:                         
            mappings = new apiPath("proarc/api","CurrentUser")               
            break; 
        case buttonActionTypes.GET_MY_GROUPS:                         
            mappings = new apiPath("MLayer/user",`${param}/groups`)               
            break; 
        case buttonActionTypes.LOG_PDF_VIEW:                         
            mappings = new apiPath("MLayer","PdfView")               
            break; 
        case buttonActionTypes.GET_CONFIG:                         
            mappings = new apiPath("proarc-sts/proarc/api/Settings/section","search")                 
            break;     
        case buttonActionTypes.SEARCH_DOCS:                         
            mappings = new apiPath("proarc/api/GlobalSearch/document","search")                 
            break;  
        case buttonActionTypes.GET_REVISION_PERMISIONS:                         
            mappings = new apiPath("proarc-bl/IPermissionManager","GetRevisionUserAccess")                 
            break;  
        case buttonActionTypes.GET_RECENT_DOCS:                                        
            mappings = new apiPath("proarc/api/document/folders/recent","search")                 
            break;
        case buttonActionTypes.GET_FAVORITE_DOCS:                    
            mappings = new apiPath("proarc/api/document/folders/favourite","search")                 
            break;
        case buttonActionTypes.GET_MY_ACTIVITIES:                         
            mappings = new apiPath("proarc-bl/IActivityManager","GetActivityItems")                 
            break;
        case buttonActionTypes.GET_ACTIVITY_DOCUMENTS:                         
            mappings = new apiPath("proarc/api/workflow",`${param}/documents`)            
            break; 
        case buttonActionTypes.GET_ACTIVITY_DECISIONS:                         
            mappings = new apiPath("proarc/api/workflow",`${param}/activity/${param2}/Decisions`)            
            break; 
        case buttonActionTypes.ACK_ACTIVITY:                         
            mappings = new apiPath("proarc/api/workflow",`${param}/activity/${param2}/Acknowledge`)            
            break; 
        case buttonActionTypes.GET_WF_COMMENTS:                         
            mappings = new apiPath("proarc/api/workflow",`${param}/activity/${param2}/comments/search`)            
            break; 
        case buttonActionTypes.ADD_WF_COMMENT:                         
            mappings = new apiPath("proarc/api/workflow",`${param}/activity/${param2}/comments`)            
            break; 
        case buttonActionTypes.CLOSE_ACTIVITY:                         
            mappings = new apiPath("proarc/api/workflow",`${param}/activity/${param2}/close`)            
            break; 
        case buttonActionTypes.ADD_DOC_COMMENT:                         
            mappings = new apiPath("proarc/api/document",`${param}/comments`)            
            break; 
        case buttonActionTypes.ADD_TO_FAVORITES:                         
            mappings = new apiPath("proarc/api/document/folders/favourite/add",`${param}`)            
            break; 
        case buttonActionTypes.REMOVE_FROM_FAVORITES:                         
            mappings = new apiPath("proarc/api/document/folders/favourite/remove",`${param}`)         
            break; 
        case buttonActionTypes.GET_DOCUMENTS:                         
            mappings = new apiPath("proarc-bl/IDocumentManager","GetDocumentProfiles")                 
            break;
        case buttonActionTypes.CHECK_IN_FILE:                         
            mappings = new apiPath("proarc-bl/IFileManager","CheckInFile")                 
            break;
        case buttonActionTypes.OPEN_FILE:                         
            mappings = new apiPath("proarc-bl/IFileManager","OpenFile")            
            break;  
        case buttonActionTypes.GET_WF_DEFAULT_RECIPIENTS:                         
            mappings = new apiPath("proarc/api/workflow/template",`${param}/recipient/default`)               
            break;  
        case buttonActionTypes.CREATE_WORKFLOW:                         
            mappings = new apiPath("proarc/api","workflow")                 
            break;
        case buttonActionTypes.START_WORKFLOW:                         
            mappings = new apiPath("proarc/api",`workflow/${param}/Start`)                 
            break;  
        case buttonActionTypes.IMPORT_COMM_FILE:                         
            mappings = new apiPath("proarc-bl/IFileManager","ImportCommentFiles")                 
            break;
        case buttonActionTypes.GET_ACTIVITY_BL:                         
            mappings = new apiPath("proarc-bl/IActivityManager","GetActivityItem")                 
            break;
        case buttonActionTypes.GET_ACT_REC_BL:                         
            mappings = new apiPath("proarc-bl/IActivityManager","GetWorkflowActivityRecipients")                 
            break;
        case buttonActionTypes.CLOSE_ACTIVITY_BL:                         
            mappings = new apiPath("proarc-bl/IActivityManager","EndActivity")                 
            break;
      default:
            mappings = new apiPath("","")   
          } 
    return mappings;
}

export interface fileSearchResult {
    ListItems: PaFile[];
    Count: number;
}

export interface docsSearchResult {
    ListItems: PaDocument[];
    Count: number;
}